/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from 'utils/fp-js';

export const users = (state, action) =>
  FP.match(action.type).on('SET_users', action.payload).otherwise(state);
